<template>
  <div>
    <a v-if="content._type === 'simpleLink'" :href="content.urlOrPath" class="menuItemLink">{{ content.title }}</a>
    <a v-if="content._type === 'dropdownMenu'" role="button" @click="openMenus.push(menuName)" class="menuItemMore">
      <DivWithMoreArrow>{{ content.title }}</DivWithMoreArrow>
    </a>
    <SubMenuPane v-if="content._type === 'dropdownMenu'" v-bind="{ menuName, content, openMenus }" />
  </div>
</template>

<script>
import DivWithMoreArrow from '../shared/DivWithMoreArrow.vue'
import SubMenuPane from './SubMenuPane.vue'

export default {
  components: {
    DivWithMoreArrow,
    SubMenuPane,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    openMenus: {
      type: Array,
      required: true,
    },
  },
  computed: {
    menuName() {
      return this.content.title
    }
  },
}
</script>

<style scoped>

.menuItemLink, .menuItemMore {
  display: block;
  padding: var(--spacing-7) 0;
  border-bottom: thin solid var(--menu-hairline-color);
  font-size: var(--font-size-4);
}

.menuItemMore {
  cursor: pointer;
}
</style>
